import React from "react"
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { formatDateTime } from "../../helpers/utils";
import { getP24ImplementationTypeById } from "../../constants/P24ImplementationType";

/**
 * Komponent wyświetlający logi poszczególnej transakcji
 */
class P24TrasactionLogs extends React.Component {

    componentDidMount() {
        
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };

    render() {
        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">Logi w systemie Flow24</h2>
                </div>

                <LogItemList items={this.props.logs} />

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            {this.props.submitText}
                        </button>
                    </div>
                </form>
            </div >
        )
    }

}

//ustawienie domyslnych pol
P24TrasactionLogs.defaultProps = {
    submitText: 'Zamknij'
}

P24TrasactionLogs.propTypes = {
    //lista logów do tabelki
    logs: PropTypes.array.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired
}

export default P24TrasactionLogs;

/**
 * Komponent wyświetlający kolekcję logów
 * 
 * @param {*} items kolekcja logów
 */
const LogItemList = ({ items }) => {

    //sprawdzamy czy sa jakies elementy, aby dodac scrolla, a innym wypadku nie chcemy takeigo duzego modala
    if (items.length > 0) {
        return (
            <div style={{ overflowY: 'auto', maxHeight: '700px' }}>
                {items.map(item => <LogItem key={item.id} item={item} />)}
            </div>
        )
    }

    return (
        <div className="w3-center">
            &lt;Brak&gt;
        </div>
    )
}

/**
 * Pojedyńczy log
 * 
 * @param {*} item  log
 */
const LogItem = ({ item }) => {
    return (
        <div>
            <div className="w3-container w3-green">
                <h5 className="w3-center">{item.serviceType} ({getP24ImplementationTypeById(item.implType).displayText}) - {formatDateTime(item.creationDate)}</h5>
            </div>

            <div className="w3-container">

                <div className="w3-row-padding">
                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {item.method}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.method"
                                defaultMessage="method"
                            />
                        </label>
                    </div>

                    <div className="w3-col s8">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {item.uri}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.uri"
                                defaultMessage="uri"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {item.responseStatus}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.responseStatus"
                                defaultMessage="responseStatus"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {item.id}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.id"
                                defaultMessage="id"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {item.restaurantId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.restaurantId"
                                defaultMessage="restaurantId"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {item.p24MerchantId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.p24MerchantId"
                                defaultMessage="p24MerchantId"
                            />
                        </label>
                    </div>

                    <div className="w3-col s6">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {item.sessionId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.sessionId"
                                defaultMessage="sessionId"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s5">
                        <span className="w3-input w3-right-align" style={{ height: '195px', overflowWrap: 'break-word', overflow: 'auto' }}>
                            {item.requestHeader}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.requestHeader"
                                defaultMessage="requestHeader"
                            />
                        </label>
                    </div>
                    <div className="w3-col s7">
                        <span className="w3-input" style={{ height: '195px', overflowWrap: 'break-word', overflow: 'auto' }}>
                            {item.requestBody}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.requestBody"
                                defaultMessage="requestBody"
                            />
                        </label>
                    </div>
                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s5">
                        <span className="w3-input w3-right-align" style={{ height: '195px', overflowWrap: 'break-word', overflow: 'auto' }}>
                            {item.responseHeader}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.responseHeader"
                                defaultMessage="responseHeader"
                            />
                        </label>
                    </div>
                    <div className="w3-col s7">
                        <span className="w3-input" style={{ height: '195px', overflowWrap: 'break-word', overflow: 'auto' }}>
                            {item.responseBody}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Log.responseBody"
                                defaultMessage="responseBody"
                            />
                        </label>
                    </div>
                </div>

            </div>
        </div>
    )
}